import React from 'react';

/** The sticky column header of the List view (Boards Redesign card 6.2): the
 *  same `--list-grid` columns as every TaskListRow, so the labels sit over
 *  their cells. "Owner" only on a team board — a personal board has no
 *  assignees, so the column would label nothing. Subtasks sits between Due
 *  and Comments, as on the ListView artboard. */
export default function ListColumnHeader({ isTeamBoard = false }) {
  return (
    <div className="task-board-list-colheader" role="presentation" aria-hidden="true">
      <span />
      <span />
      <span className="task-board-list-colheader--center task-board-list-colheader--owner">{isTeamBoard ? 'Owner' : ''}</span>
      <span />
      <span>Task</span>
      <span className="task-board-list-colheader--labels">Labels</span>
      <span>Due</span>
      <span className="task-board-list-colheader--subtasks">Subtasks</span>
      <span className="task-board-list-colheader--center task-board-list-colheader--comments">Comments</span>
      <span />
    </div>
  );
}
